module.exports = __webpack_public_path__ + "static/media/3.0b46459.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/3.mp3
// module id = 7xNN
// module chunks = 0